import { useSelector } from "react-redux";
import { ITareaResolverPost } from "../../interfaces/backendApi/tareaResover";
import { RootState } from "../../redux/rootReducers";

export const SwitchIdContratoTarea = (
  iTareaResolverPost: ITareaResolverPost,
  IdContratoTarea: number,
  contratoTarea: any,
) => {
  if (IdContratoTarea === 1) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskMasInformacion: {
        serviceRequestInput: {
          notas: contratoTarea.serviceRequestInput.notas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
        },
      },
    });
    return data;
  }
  if (IdContratoTarea === 2) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskAprobacion: {
        serviceRequestInput: {
          notas: contratoTarea.serviceRequestInput.notas,
          horasAprobadas: contratoTarea.serviceRequestInput.horasAprobadas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
        },
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 3) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskCalificacion: {
        serviceRequestInput: {
          validarSatisfaccion:
            contratoTarea.serviceRequestInput.validarSatisfaccion,
          notas: contratoTarea.serviceRequestInput.notas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
        },
      },
    });
    return data;
  }
  if (IdContratoTarea === 4) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskCasoParticular: {
        serviceRequestInput: {
          categoria: contratoTarea.serviceRequestInput.categoria,
          notas: contratoTarea.serviceRequestInput.notas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          asignacion: contratoTarea.serviceRequestInput.asignacion,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
      },
    });
    return data;
  }
  if (IdContratoTarea === 5) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskClienteDisconforme: {
        serviceRequestInput: {
          notas: contratoTarea.serviceRequestInput.notas,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
          estado: contratoTarea.serviceRequestInput.estado,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
      },
    });
    return data;
  }
  if (IdContratoTarea === 6) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskGestionarCliente: {
        serviceRequestInput: {
          tiempo: contratoTarea.serviceRequestInput.tiempo,
          notas: contratoTarea.serviceRequestInput.notas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          horasAprobadas: contratoTarea.serviceRequestInput.horasAprobadas,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 7) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskEstimacion: {
        estimar22Input: {
          categoria: contratoTarea.estimar22Input.categoria,
          tiempo: contratoTarea.estimar22Input.tiempo,
          prioridad: contratoTarea.estimar22Input.prioridad,
          fechaEsperada: contratoTarea.estimar22Input.fechaEsperada,
          validarSatisfaccion: contratoTarea.estimar22Input.validarSatisfaccion,
          estado: contratoTarea.estimar22Input.estado,
          horasAprobadas: contratoTarea.estimar22Input.horasAprobadas,
          asignacion: contratoTarea.estimar22Input.asignacion,
          notasInternas: contratoTarea.estimar22Input.notasInternas,
          ci: contratoTarea.estimar22Input.ci,
          skill: contratoTarea.estimar22Input.skill,
          descripcion: contratoTarea.estimar22Input.descripcion,
          alarma: contratoTarea.estimar22Input.alarma,
        },
        tiempo22Input: [
          {
            persistenceId_string:
              contratoTarea.tiempo22Input[0].persistenceId_string,
            tarea: contratoTarea.tiempo22Input[0].tarea,
            estado: contratoTarea.tiempo22Input[0].estado,
            usuario: contratoTarea.tiempo22Input[0].usuario,
            cantidad: contratoTarea.tiempo22Input[0].cantidad,
          },
        ],
        tiempoEstim22Input: [...contratoTarea.tiempoEstim22Input],
      },
    });
    return data;
  }
  if (IdContratoTarea === 8) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      EscalamientoN3: iTareaResolverPost.EscalamientoN3,
      taskResolucion: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          tiempo: contratoTarea.resolverInput.tiempo,
          prioridad: contratoTarea.resolverInput.prioridad,
          horasAprobadas: contratoTarea.resolverInput.horasAprobadas,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 9) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskRevision: {
        serviceRequestInput: {
          categoria: contratoTarea.serviceRequestInput.categoria,
          tiempo: contratoTarea.serviceRequestInput.tiempo,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          asignacion: contratoTarea.serviceRequestInput.asignacion,
          impacto: contratoTarea.serviceRequestInput.impacto,
          notas: contratoTarea.serviceRequestInput.notas,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
          ci: contratoTarea.serviceRequestInput.ci,
          ci_tipo: contratoTarea.serviceRequestInput.ci_tipo,
          ci_id: contratoTarea.serviceRequestInput.ci_id,
          ambiente: contratoTarea.serviceRequestInput.ambiente,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 10) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskRmHsAdicionales: {
        serviceRequestInput: {
          alarma: contratoTarea.serviceRequestInput.alarma,
          descripcion: contratoTarea.serviceRequestInput.descripcion,
          categoria: contratoTarea.serviceRequestInput.categoria,
          tiempo: contratoTarea.serviceRequestInput.tiempo,
          notas: contratoTarea.serviceRequestInput.notas,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          horasAprobadas: contratoTarea.serviceRequestInput.horasAprobadas,
          asignacion: contratoTarea.serviceRequestInput.asignacion,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
          ci: contratoTarea.serviceRequestInput.ci,
          ci_tipo: contratoTarea.serviceRequestInput.ci_tipo,
          ci_id: contratoTarea.serviceRequestInput.ci_id,
          tiempoAdicional: contratoTarea.serviceRequestInput.tiempoAdicional,
          skill: contratoTarea.serviceRequestInput.skill,
          tiempoAdicionalH: contratoTarea.serviceRequestInput.tiempoAdicionalH,
        },
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 11) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskEstimSinAtender: {
        estimar22Input: {
          alarma: contratoTarea.estimar22Input.alarma,
          descripcion: contratoTarea.estimar22Input.descripcion,
          categoria: contratoTarea.estimar22Input.categoria,
          notas: contratoTarea.estimar22Input.notas,
          prioridad: contratoTarea.estimar22Input.prioridad,
          fechaEsperada: contratoTarea.estimar22Input.fechaEsperada,
          estado: contratoTarea.estimar22Input.estado,
          asignacion: contratoTarea.estimar22Input.asignacion,
          notasInternas: contratoTarea.estimar22Input.notasInternas,
          impacto: contratoTarea.estimar22Input.impacto,
        },
      },
    });
    return data;
  }
  if (IdContratoTarea === 12) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskResolucionOperador: {
        tareaOperadorInput: {
          tipoTarea: contratoTarea.tareaOperadorInput.tipoTarea,
          descTarea: contratoTarea.tareaOperadorInput.descTarea,
          fechaCreacion: contratoTarea.tareaOperadorInput.fechaCreacion,
        },
      },
    });
    return data;
  }
  if (IdContratoTarea === 13) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskGestionarTp: {
        serviceRequestInput: {
          alarma: contratoTarea.serviceRequestInput.alarma,
          descripcion: contratoTarea.serviceRequestInput.descripcion,
          categoria: contratoTarea.serviceRequestInput.categoria,
          tiempo: contratoTarea.serviceRequestInput.tiempo,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          asignacion: contratoTarea.serviceRequestInput.asignacion,
          ci: contratoTarea.serviceRequestInput.ci,
          ci_tipo: contratoTarea.serviceRequestInput.ci_tipo,
          ci_id: contratoTarea.serviceRequestInput.ci_id,
          skill: contratoTarea.serviceRequestInput.skill,
          impacto: contratoTarea.serviceRequestInput.impacto,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
          notas: contratoTarea.serviceRequestInput.notas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
            usuario: contratoTarea.tiempoInput[0].usuario,
          },
        ],
      },
    });
    return data;
  }
  if (IdContratoTarea === 14) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskValidacion: {
        resolverInput: {
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          categoria: contratoTarea.resolverInput.categoria,
          tiempo: contratoTarea.resolverInput.tiempo,
          prioridad: contratoTarea.resolverInput.prioridad,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          asignacion: contratoTarea.resolverInput.asignacion,
          ci: contratoTarea.resolverInput.ci,
          ci_tipo: contratoTarea.resolverInput.ci_tipo,
          ci_id: contratoTarea.resolverInput.ci_id,
          skill: contratoTarea.resolverInput.skill,
          impacto: contratoTarea.resolverInput.impacto,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          notas: contratoTarea.resolverInput.notas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 15) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskResolucionTp: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          tiempo: contratoTarea.resolverInput.tiempo,
          prioridad: contratoTarea.resolverInput.prioridad,
          horasAprobadas: contratoTarea.resolverInput.horasAprobadas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 16) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskEvaluarDisponibilidad: {
        resolverInput: {
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          categoria: contratoTarea.resolverInput.categoria,
          tiempo: contratoTarea.resolverInput.tiempo,
          notas: contratoTarea.resolverInput.notas,
          prioridad: contratoTarea.resolverInput.prioridad,
          estado: contratoTarea.resolverInput.estado,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          asignacion: contratoTarea.resolverInput.asignacion,
          notaInternas: contratoTarea.resolverInput.notaInternas,
          ci: contratoTarea.resolverInput.ci,
          ci_tipo: contratoTarea.resolverInput.ci_tipo,
          ci_id: contratoTarea.resolverInput.ci_id,
          skill: contratoTarea.resolverInput.skill,
          impacto: contratoTarea.resolverInput.impacto,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 17) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskEscalacion: {
        resolverInput: {
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          categoria: contratoTarea.resolverInput.categoria,
          tiempo: contratoTarea.resolverInput.tiempo,
          notas: contratoTarea.resolverInput.notas,
          prioridad: contratoTarea.resolverInput.prioridad,
          estado: contratoTarea.resolverInput.estado,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          asignacion: contratoTarea.resolverInput.asignacion,
          notaInternas: contratoTarea.resolverInput.notaInternas,
          ci: contratoTarea.resolverInput.ci,
          ci_tipo: contratoTarea.resolverInput.ci_tipo,
          ci_id: contratoTarea.resolverInput.ci_id,
          skill: contratoTarea.resolverInput.skill,
          impacto: contratoTarea.resolverInput.impacto,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 18) {
    let data = JSON.stringify({
      Id: String(iTareaResolverPost.IdTarea),
      tareaOperadorInput: {
        tipoTarea: contratoTarea.tareaOperadorInput.tipoTarea,
        descTarea: contratoTarea.tareaOperadorInput.descTarea,
        fechaCreacion: contratoTarea.tareaOperadorInput.fechaCreacion,
      },
    });
    return data;
  }

  if (IdContratoTarea === 19) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskReunion: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          tiempo: contratoTarea.resolverInput.tiempo,
          prioridad: contratoTarea.resolverInput.prioridad,
          horasAprobadas: contratoTarea.resolverInput.horasAprobadas,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }

  if (IdContratoTarea === 20) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskGestionCasoVencido: {
        serviceRequestInput: {
          alarma: contratoTarea.serviceRequestInput.alarma,
          descripcion: contratoTarea.serviceRequestInput.descripcion,
          categoria: contratoTarea.serviceRequestInput.categoria,
          tiempo: contratoTarea.serviceRequestInput.tiempo,
          prioridad: contratoTarea.serviceRequestInput.prioridad,
          fechaEsperada: contratoTarea.serviceRequestInput.fechaEsperada,
          estado: contratoTarea.serviceRequestInput.estado,
          asignacion: contratoTarea.serviceRequestInput.asignacion,
          ci: contratoTarea.serviceRequestInput.ci,
          ci_tipo: contratoTarea.serviceRequestInput.ci_tipo,
          ci_id: contratoTarea.serviceRequestInput.ci_id,
          skill: contratoTarea.serviceRequestInput.skill,
          impacto: contratoTarea.serviceRequestInput.impacto,
          notasInternas: contratoTarea.serviceRequestInput.notasInternas,
          notas: contratoTarea.serviceRequestInput.notas,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
            usuario: contratoTarea.tiempoInput[0].usuario,
          },
        ],
      },
    });
    return data;
  }

  if (IdContratoTarea === 21) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskCasoSimplificado: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          alarma: contratoTarea.resolverInput.alarma,
          descripcion: contratoTarea.resolverInput.descripcion,
          tiempo: contratoTarea.resolverInput.tiempo,
          prioridad: contratoTarea.resolverInput.prioridad,
          horasAprobadas: contratoTarea.resolverInput.horasAprobadas,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 22) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskMasInfoTecnico: {
        resolverInput: {
          notas: contratoTarea.resolverInput.notas,
        },
      },
    });
    return data;
  }

  if (IdContratoTarea === 23) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskValidarPedido: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          prioridad: contratoTarea.resolverInput.prioridad,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 24) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskMasInfoRm: {
        resolverInput: {
          notas: contratoTarea.resolverInput.notas,
        },
      },
    });
    return data;
  }
  if (IdContratoTarea === 25) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskAprobarPedido: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          prioridad: contratoTarea.resolverInput.prioridad,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 26) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskSolicitud: {
        resolverInput: {
          categoria: contratoTarea.resolverInput.categoria,
          notas: contratoTarea.resolverInput.notas,
          fechaEsperada: contratoTarea.resolverInput.fechaEsperada,
          estado: contratoTarea.resolverInput.estado,
          notasInternas: contratoTarea.resolverInput.notasInternas,
          ci: contratoTarea.resolverInput.ci,
          skill: contratoTarea.resolverInput.skill,
          prioridad: contratoTarea.resolverInput.prioridad,
          asignacion: contratoTarea.resolverInput.asignacion,
        },
        tiempoInput: [
          {
            persistenceId_string:
              contratoTarea.tiempoInput[0].persistenceId_string,
            tarea: contratoTarea.tiempoInput[0].tarea,
            estado: contratoTarea.tiempoInput[0].estado,
            usuario: contratoTarea.tiempoInput[0].usuario,
            cantidad: contratoTarea.tiempoInput[0].cantidad,
          },
        ],
        tiempoEstimInput: [...contratoTarea.tiempoEstimInput],
      },
    });
    return data;
  }
  if (IdContratoTarea === 27) {
    let data = JSON.stringify({
      IdModo: iTareaResolverPost.IdModo,
      IdTarea: iTareaResolverPost.IdTarea,
      TipoTarea: iTareaResolverPost.TipoTarea,
      Usuario: iTareaResolverPost.Usuario,
      NotasRedmine: iTareaResolverPost.NotasRedmine,
      taskEsperaInfo: {
        resolverInput: {
          notas: contratoTarea.resolverInput.notas,
          estado: contratoTarea.resolverInput.estado,
        },
      },
    });
    return data;
  }
};

export const SwitchIdPerfilIdNotificacion = (isIdTipo?: number) => {
  let idTipo = 1;
  const { IdPerfil } = useSelector((store: RootState) => store.login);
  const idPerfil = IdPerfil ? Number(IdPerfil) : 0;
  // if (idPerfil === 0) {
  //   idTipo = 1;
  // }
  // if (idPerfil === 1) {
  //   idTipo = 1;
  // }
  // if (idPerfil === 2) {
  //   idTipo = 2;
  // }
  // if (idPerfil === 3) {
  //   idTipo = 3;
  // }
  // if (idPerfil === 4) {
  //   idTipo = 4;
  // }
  // if (idPerfil === 6) {
  //   idTipo = 6;
  // }
  if (isIdTipo && idPerfil === 2) {
    idTipo = isIdTipo;
  }
  return idTipo;
};
